// Import Package
import React, { useEffect, useState } from "react";
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../recoil-store/recoil-state';
import { useTranslation } from "react-i18next";

// Import Pages
import FieldLabel from "../../../../components/FlowConfigurationInputs/FieldLabel/FieldLabel";

// Import Material UI
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InfoIcon from "@material-ui/icons/Info";
import Tooltip from '@material-ui/core/Tooltip';

// Import Services
import SettingsService from "../../../../services/SettingsService/SettingsService";
import { validateEmail } from "../../../../helpers/helper";

// Import CSS
import "./MailServer.css";

function MailServer(props) {
  const { t } = useTranslation();
  const [type, setType] = useState("SMTP");
  const [enable, setEnable] = useState(true);
  const [auth, setAuth] = useState(false);
  const [testMail, setTestMail] = useState("");
  const [host, setHost] = useState("");
  const [fromMail, setFrom] = useState("");
  const [port, setPort] = useState("");
  const [sender, setSender] = useState("");
  const [values, setValues] = useState({
    username: "",
    password: "",
    showPassword: false,
  });
  const setAlert = useSetRecoilState(alertState);
  const label = "CONTENT.SETTINGS."

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const res = await SettingsService.getMail();
    if (res?.status) {
      setEnable(res.data.is_tls);
      setType(res.data.protocol);
      setFrom(res.data.from);
      setPort(res.data.port);
      setHost(res.data.host);
      setSender(res.data.sender_name);
      setValues({ id: res.data.id, username: res.data.user, password: res.data.password });
    }
  }

  const handleSave = async () => {
    await SettingsService.postMail({
      is_tls: enable,
      protocol: type,
      from: fromMail,
      port, host,
      sender_name: sender,
      username: values.username,
      password: values.password,
      id: values.id
    })

    setAlert(alert => ({
      ...alert,
      show: true,
      message: t('MESSAGES.SETTINGS.MAIL-SERVER.SAVE-SUCCESS'),
      severity: 'success'
    }));
  }

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handleRestore = () => {
    fetchData().then(res => {
      setAuth(false)
      setEnable(false)
      setType("SMTP")
    })
  };

  // const handleClickShowPassword = () => {
  //   setValues({ ...values, showPassword: !values.showPassword });
  // };

  // const handleMouseDownPassword = (event) => {
  //   event.preventDefault();
  // };

  const handleSendTestMail = async () => {
    const response = await SettingsService.sendMail({ mailAddress: testMail })
    if (response) {
      //successfully
      if (response?.status) {
        setAlert(alert => ({ ...alert, show: true, message: t('CONTENT.SETTINGS.MAIL-SERVER.TEST-MAIL-SUCCESS'), severity: 'success' }));
      }
      else {
        setAlert(alert => ({ ...alert, show: true, message: t(label + `MAIL-SERVER.${response.message}`), severity: 'error' }));
      }
    } else {
      setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }));
    }
  }
  const handleChangeMailInput = (event) => {
    setTestMail(event.target.value)
  }
  return (
    <div className="container">
      <span className="header"> {t(label + 'MAIL-SERVER.MAIL-SERVER')}</span>
      <hr className="seperator header-seperator" />


      {/* <div>{t("CONTENT.SETTINGS.MAIL-SERVER.MAIL-SERVER")}</div> */}
      <Grid container spacing={4}>
        <Grid className="mail-server-grid" item xs={12} lg={6} style={{ marginBottom: "15px" }}>
          <div className="mail-server-text" >
            <FieldLabel classes={"sub-header"} name={t(label + "MAIL-SERVER.SERVER-NAME")} />
          </div>
          {/* <div className="mail-server-line" /> */}
          <div className="mail-server-input-text">
            <input type="text" className="mail-server-input" value={host} placeholder={t(label + "MAIL-SERVER.ENTER-HOST-ADDRESS")} onChange={(e) => { setHost(e.target.value) }} />
          </div>
        </Grid>
        <Grid className="mail-server-grid" item xs={12} lg={6} style={{ marginBottom: "15px" }}>
          <div className="mail-server-text">
            <FieldLabel classes={"sub-header"} name={t(label + "MAIL-SERVER.PORT-SSL")} is_required />
          </div>
          {/* <div className="mail-server-line" /> */}
          <div className="mail-server-input-text">
            <input type="number" className="mail-server-input" value={port} placeholder={t(label + "MAIL-SERVER.ENTER-PORT-SSL")} onChange={(e) => { setPort(e.target.value) }} />
          </div>
        </Grid>
        <Grid className="mail-server-grid" item xs={12} lg={6}>
          <div className="mail-server-text">
            {/* {t("CONTENT.SETTINGS.MAIL-SERVER.SENDER-NAME")} */}
            <FieldLabel classes={"sub-header"} name={t(label + "MAIL-SERVER.SENDER-NAME")} />
          </div>
          {/* <div className="mail-server-line" /> */}
          <div className="mail-server-input-text">
            <input type="text" className="mail-server-input" value={sender} placeholder={t(label + "MAIL-SERVER.ENTER-SENDERS-NAME")} onChange={(e) => { setSender(e.target.value) }} />
          </div>
        </Grid>
        <Grid className="mail-server-grid" item xs={12} lg={6}>
          <div className="mail-server-text">
            <FieldLabel classes={"sub-header"} name={t(label + "MAIL-SERVER.SENDER-MAIL")} />
          </div>
          {/* <div className="mail-server-line" /> */}
          <div className="mail-server-input-text">
            <input type="text" className="mail-server-input" value={fromMail} placeholder={t(label + "MAIL-SERVER.ENTER-SENDERS-EMAIL")} onChange={(e) => { setFrom(e.target.value) }} />
            {/* <small onClick={handleSendTestMail} style={{ pointerEvents: testMail.length <= 1 || disableSendMail ? "none" : "auto" }} className="mail-server-small-text-link">
              {t("CONTENT.SETTINGS.MAIL-SERVER.SEND-TEST-MAIL")}
            </small> */}
          </div>
        </Grid>
        <div className="p-16 mail-server-test-email-container">
          <div className="mail-server-text">
            <FieldLabel classes={"sub-header"} name={t(label + "MAIL-SERVER.SENDER-TEST-MAIL")} />
          </div>
          {/* <div className="mail-server-line" /> */}
          <div className="mail-server-input-text">
            <input type="text" className="mail-server-input" value={testMail} placeholder={t(label + "MAIL-SERVER.ENTER-SENDERS-EMAIL")} onChange={(e) => handleChangeMailInput(e)} />
            <small onClick={handleSendTestMail} style={{ pointerEvents: testMail.length <= 1 ? "none" : "auto", opacity: testMail.length <= 1 ? "0.5" : "1" }} className="mail-server-small-text-link">
              {t("CONTENT.SETTINGS.MAIL-SERVER.SEND-TEST-MAIL")}
            </small>
          </div>
        </div>
        <Grid className="mail-server-grid" item xs={12} lg={6} style={{ margin: "25px 0" }}>
          <FormControlLabel
            control={
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                checked={auth}
                onClick={() => setAuth(!auth)}
                style={{ color: auth && "#43AA41" }}
              />
            }
            label={
              <div className="mail-server-checkbox-label">
                {t("CONTENT.SETTINGS.MAIL-SERVER.REQUIRED-AUTH")}
              </div>
            }
          />

          {/* <div className="mail-server-line" /> */}
          {/* <div className="mail-server-head-list">


          </div> */}
        </Grid>
        <Grid className="mail-server-grid" item xs={12} lg={6} style={{ margin: "25px 0" }}>
          <div className="mail-server-head-list">
            <div className="mail-server-text">
              <div className="server-title sub-header">
                {t("CONTENT.SETTINGS.MAIL-SERVER.MAIL-TYPE")}
              </div>
              <div className="mail-server-button-group">
                <div
                  onClick={() => setType("SMTP")}
                  className={
                    type === "SMTP"
                      ? "mail-server-button-active"
                      : "mail-server-button"
                  }
                >
                  {t("CONTENT.SETTINGS.MAIL-SERVER.SMTP")}
                </div>
                <div
                  onClick={() => setType("SMTPS")}
                  className={
                    type === "SMTPS"
                      ? "mail-server-button-active"
                      : "mail-server-button"
                  }
                >
                  {t("CONTENT.SETTINGS.MAIL-SERVER.SMTPS")}
                </div>
              </div>
            </div>
            <div className="mail-server-text tls-text">
              <div className="server-title sub-header ">
                {t("CONTENT.SETTINGS.MAIL-SERVER.ENABLE-TLS")}
              </div>
              <div className="mail-server-button-group">
                <div
                  onClick={() => setEnable(true)}
                  className={
                    enable === true
                      ? "mail-server-button-active"
                      : "mail-server-button"
                  }
                >
                  {t("CONTENT.SETTINGS.MAIL-SERVER.YES")}
                </div>
                <div
                  onClick={() => setEnable(false)}
                  className={
                    enable === false
                      ? "mail-server-button-active"
                      : "mail-server-button"
                  }
                >
                  {t("CONTENT.SETTINGS.MAIL-SERVER.NO")}
                </div>
              </div>
            </div>
          </div>
        </Grid>
        {/* <Grid className="mail-server-grid" item xs={12} style={{ margin: "20px 0 20px 0" }}>

        </Grid> */}
        {auth === true && (
          <>
            <Grid className="mail-server-grid" item xs={12} lg={6} >
              <div className="mail-server-text">
                <FieldLabel classes={"sub-header"} name={t(label + "MAIL-SERVER.USERNAME")} />
                {/* {t("CONTENT.SETTINGS.MAIL-SERVER.USERNAME")} */}
              </div>
              {/* <div className="mail-server-line" /> */}
              <div className="mail-server-input-text">
                <input type="text" className="mail-server-input"
                  value={values.username}
                  placeholder={t(label + "MAIL-SERVER.ENTER-USERNAME")}
                  onChange={handleChange("username")} />
              </div>
            </Grid>
            <Grid className="mail-server-grid" item xs={12} lg={6}>
              <div className="mail-server-text">
                <FieldLabel classes={"sub-header"} name={t(label + "MAIL-SERVER.PASSWORD")} />
                {/* {t("CONTENT.SETTINGS.MAIL-SERVER.PASSWORD")} */}
              </div>
              {/* <div className="mail-server-line" /> */}
              <div className="mail-server-focused">
                <input
                  className="mail-server-input-text-input mail-server-input"
                  type={"password"}
                  value={values.password}
                  placeholder={t(label + "MAIL-SERVER.ENTER-PASSWORD")}
                  onChange={handleChange("password")}
                // endAdornment={
                //   <InputAdornment position="end">
                //     <IconButton
                //       aria-label="toggle password visibility"
                //       onClick={handleClickShowPassword}
                //       onMouseDown={handleMouseDownPassword}
                //       edge="end"
                //     >
                //       {values.showPassword ? (
                //         <Visibility />
                //       ) : (
                //         <VisibilityOff />
                //       )}
                //     </IconButton>
                //   </InputAdornment>
                // }
                />
              </div>
            </Grid>
          </>
        )}
        {/* <Grid item xs={12} lg={6} spacing={4} style={{ marginTop: auth && 10, marginBottom: auth && 10 }}>
          <div className="mail-server-text">
            {t("CONTENT.SETTINGS.MAIL-SERVER.TEST-MAIL")}<span className="mandatory-field">*</span>
          </div>
          <div className="mail-server-line" />
          <div
            style={{ marginTop: 16, marginBottom: 11 }}
            className="mail-server-input-text"
          >
            <input type="text" onChange={handleChangeMailInput} />
          </div>
          <small onClick={handleSendTestMail} style={{ pointerEvents: testMail.length <= 1 || disableSendMail ? "none" : "auto" }} className="mail-server-small-text-link">
            {t("CONTENT.SETTINGS.MAIL-SERVER.SEND-TEST-MAIL")}
          </small>
        </Grid> */}
        <hr className="seperator mail-bottom-seperator" />

        <Grid className="mail-server-grid" item xs={12} style={{ margin: "0", paddingRight: "0px" }}>
          <div className="mail-server-bottom-section">
            <div className="button-save" onClick={handleSave}>
              {t(label + "MAIL-SERVER.SAVE")}
            </div>
            {/* <div className="mail-server-button-cancel">
              {t(label + "MAIL-SERVER.CANCEL")}
            </div> */}
          </div>
        </Grid>
        <Grid className="mail-server-default-button-grid" item xs={12} style={{ margin: "0" }}>
          <div className="default-button-container">
            <button className="button-restore" onClick={handleRestore}>
              {t(label + "MAIL-SERVER.RESTORE")}
            </button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
export default MailServer;